// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  text-align: center;
  padding: 25px;
}
.wrapper ion-icon {
  width: 43px;
  height: 43px;
}
.wrapper h3 {
  color: var(--ion-color-secondary);
  font-family: Tusker, sans-serif;
  font-size: 22px;
  margin-top: 20px;
}
.wrapper .article_wrapper {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper .article_wrapper ion-img {
  width: 107px;
  height: 107px;
  object-fit: contain;
  padding: 10px;
  margin: 0px;
}
.wrapper .article_wrapper h3 {
  font-size: 18px;
  font-family: AppFont, sans-serif;
  color: var(--ion-color-primary);
  font-size: 14px;
  padding: 5px;
  margin: 5px;
}
.wrapper .article_wrapper h2 {
  font-family: Tusker, sans-serif;
  color: var(--ion-color-primary);
  font-size: 12px;
  padding-bottom: 20px;
}
.wrapper .article_wrapper ion-icon {
  width: 15px;
  height: 15px;
  margin-left: 5px;
}

.button {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: url('background_round_white.png') center center/100% 100%;
  font-family: Tusker;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--ion-color-tertiary);
}
.button_close {
  background: url('background-button.png') no-repeat center center/100% 100%;
  color: white;
  min-height: 54px;
  font-family: Tusker !important;
  text-align: center;
  font-size: 20px;
}

.uppercase-text {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-coupon-article-dialog/add-coupon-article-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;AAAE;EACE,iCAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AADI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AAGN;AADI;EACE,eAAA;EACA,gCAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAGN;AADI;EACE,+BAAA;EACA,+BAAA;EAEA,eAAA;EACA,oBAAA;AAEN;AAAI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAEN;;AAGA;EAEI,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,qEAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;AAFN;AAKI;EACE,0EAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAHN;;AAQE;EACE,yBAAA;AALJ","sourcesContent":[".wrapper {\n  text-align: center;\n  padding: 25px;\n  ion-icon {\n    width: 43px;\n    height: 43px;\n  }\n  h3 {\n    color: var(--ion-color-secondary);\n    font-family: Tusker, sans-serif;\n    font-size: 22px;\n    margin-top: 20px;\n  }\n  .article_wrapper {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    ion-img {\n      width: 107px;\n      height: 107px;\n      object-fit: contain;\n      padding: 10px;\n      margin: 0px;\n    }\n    h3 {\n      font-size: 18px;\n      font-family: AppFont, sans-serif;\n      color: var(--ion-color-primary);\n      font-size: 14px;\n      padding: 5px;\n      margin: 5px;\n    }\n    h2 {\n      font-family: Tusker, sans-serif;\n      color: var(--ion-color-primary);\n\n      font-size: 12px;\n      padding-bottom: 20px;\n    }\n    ion-icon {\n      width: 15px;\n      height: 15px;\n      margin-left: 5px;\n    }\n  }\n}\n\n.button {\n\n    height: 60px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n  \n    &:last-child {\n      margin-bottom: 0;\n    }\n  \n    &_main {\n      background: url('../../../assets/tabilo/background_round_white.png') center center / 100% 100%;\n      font-family: Tusker;\n      font-size: 20px;\n      line-height: 25px;\n      letter-spacing: 0.06em;\n      text-align: center;\n      color: var(--ion-color-tertiary);\n    }\n  \n    &_close {\n      background: url('../../../assets/tabilo/background-button.png') no-repeat center center/ 100% 100%;\n      color: white;\n      min-height: 54px;\n      font-family: Tusker !important;\n      text-align: center;\n      font-size: 20px;\n\n    }\n  }\n  \n  .uppercase-text {\n    text-transform: uppercase;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
